export default {
	FETCH_MQTT_CREDENTIALS: "FETCH_MQTT_CREDENTIALS",
	FETCH_USER_INFO: "FETCH_USER_INFO",
	INIT: "INIT"
};
